var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 23a5.685 5.685 0 00-4.4-4.033c-3.667-.697-4.033-1.834-4.033-2.567v-1.173c1.32-1.21 2.566-3.19 2.566-5.427V6.28C17.133 2.467 14.42 1 12 1S6.867 2.467 6.867 6.28V9.8c0 2.273 1.246 4.217 2.566 5.427V16.4c0 .733-.733 1.907-4.4 2.567A4.907 4.907 0 001 23",
    stroke: "#5F5F5F",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0yMyAyM0MyMi40MTMzIDIwLjk0NjcgMjAuNzI2NyAxOS4zNyAxOC42IDE4Ljk2NjdDMTQuOTMzMyAxOC4yNyAxNC41NjY3IDE3LjEzMzMgMTQuNTY2NyAxNi40VjE1LjIyNjdDMTUuODg2NyAxNC4wMTY3IDE3LjEzMzMgMTIuMDM2NyAxNy4xMzMzIDkuOFY2LjI4QzE3LjEzMzMgMi40NjY2NyAxNC40MiAxIDEyIDFDOS41OCAxIDYuODY2NjcgMi40NjY2NyA2Ljg2NjY3IDYuMjhWOS44QzYuODY2NjcgMTIuMDczMyA4LjExMzMzIDE0LjAxNjcgOS40MzMzMyAxNS4yMjY3VjE2LjRDOS40MzMzMyAxNy4xMzMzIDguNyAxOC4zMDY3IDUuMDMzMzMgMTguOTY2N0MyLjk4IDE5LjI5NjcgMS4zMyAyMC45NDY3IDEgMjMiIHN0cm9rZT0iIzVGNUY1RiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4NCjwvc3ZnPg0K";
export { SvgIconAvatar as ReactComponent };